import { Component, computed, Inject, Input, OnInit, signal } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { IdName } from '../../../../../interfaces/pricematrixmodel';
import { ChemistryInputData } from '../../../../../interfaces/streamrecurringLoad';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { FeedstockService } from '../../../../../services/feedstockservice';
import { LookUpService } from '../../../../../services/lookupservice';
import { forkJoin, takeUntil } from 'rxjs';
import { LabChemistryList, SaveStreamBiologyChemistryRequest } from '../../../../../interfaces/labchemistrymodel';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule, MatCardActions } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { formatDateOnly, normalizeNullable, normalizeNullableToString, numericInputLimit } from '../../../../shared/commonutils/helper';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { DragDropModule } from '@angular/cdk/drag-drop';
@Component({
  selector: 'app-addedit-chemistry',
  imports: [
    CommonModule,
    ReactiveFormsModule, // FIX: ngModel error
    MatCardModule,
    MatFormFieldModule, // FIX: mat-form-field error
    MatInputModule,
    MatSelectModule,
    MatSlideToggleModule,
    MatButtonModule,
    MatDatepickerModule,
    MatCheckboxModule,
    MatIconModule,
    MatDialogModule,
    DragDropModule
  ],
  templateUrl: './addedit-chemistry.component.html',
  styleUrl: './addedit-chemistry.component.scss'
})
export class AddeditChemistryComponent implements OnInit {

  chemForm!: FormGroup;
  attemptSave = signal(false);
  isSaving = signal(false);
  dateError = signal<boolean>(false); 
  isEditMode = signal<boolean>(false);
  streamID = signal<number | null>(null);
  genId = signal<number | null>(null);
  labTypes = signal<IdName[]>([]);
  displayValue = signal<string>('');
  canSave: boolean = false;
  task: string = "";
  dialogTitle = computed(() => {
    if (this.isEditMode()) {
      const id = this.data.inputData?.id;
      return 'Edit Chemistry (ID: ' + id + ')';
    }
    return 'Add Chemistry';
  });

  constructor(private fsService: FeedstockService,
    private lookup: LookUpService,
    public dialogRef: MatDialogRef<AddeditChemistryComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ChemistryInputData,
    private cForm: FormBuilder,private dialog: MatDialog) { 

      console.log("chemistry Dialog data:", data);
      this.streamID.set(data.streamId);
      this.genId.set(data.genId);
      this.task = data.task;
      if(data.inputData){  
        this.isEditMode.set(true);
      }
      this.canSave = data.canSave;
    }

  ngOnInit(): void {
    
    this._initializeForm();
    this.loadDropdownData();
  }

  private _initializeForm(): void {
    this.chemForm = this.cForm.group({
      id: [0],
      c_StreamID: [this.streamID()],
      c_LabId: ['', Validators.required],
      testing_Type: ['', Validators.required],
      c_SampleID: ['', Validators.maxLength(15)],
      c_LabreportID: ['', [Validators.required, Validators.maxLength(15)]],
      c_DateSampled: [new Date()],
      c_DateTested: [new Date()],
      cod: [null],
      tvs: [null, Validators.max(100)],
      ts: [null, Validators.max(100)],
      chlorides: [''],
      density: [''],
      totalCarbon: [''],
      ammonia: [''],
      tkn: ['', Validators.maxLength(10)],
      totalNitrogen: [''],
      totalSulfur: ['', Validators.maxLength(10)],
      sulfides: ['', Validators.maxLength(10)],
      phosphate: ['', Validators.maxLength(10)],
      potassium: ['', Validators.maxLength(10)],
      pH: [''],
      sodium: ['', Validators.maxLength(10)],
      calcium: ['', Validators.maxLength(10)],
      magnesium: ['', Validators.maxLength(10)],
      iron: ['', Validators.maxLength(10)],
      methanol: ['', Validators.maxLength(10)],
      oilsAndGrease: ['', Validators.maxLength(10)],
      notes: ['', Validators.maxLength(3000)],
    });
  }

  loadDropdownData() {    
    this.lookup.getLabTypes().subscribe({
      next: (data: IdName[]) => {
        this.labTypes.set(data);
        if(this.isEditMode()){
          this.populateFormData(this.data.inputData);
        }
      }
    });
  }

  roundOffPercentage(event: Event, controlName: string): void {
    const input = event.target as HTMLInputElement;
    let val = numericInputLimit(event, 99, 2);
  
    if (val && !val.endsWith('.') && !isNaN(Number(val))) {
      const num = Number(val);
  
      if (num > 100) {
        val = '100';
      }
    }
  
    input.value = val;
  
    const ctrl = this.chemForm.get(controlName);
  
    if (val === '' || val === '.') {
      ctrl?.setValue(null, { emitEvent: false });
    } else if (val.endsWith('.')) {
      ctrl?.setErrors({ incompleteDecimal: true });
    } else {
      ctrl?.setValue(parseFloat(val), { emitEvent: false });
    }
  
    requestAnimationFrame(() => {
      if (document.activeElement === input) {
        input.value = val;
      }
    });
  }

  roundOff(event: Event, maxValue: number, maxDecimals: number, type: number, controlName: string): void {
    const input = event.target as HTMLInputElement;
    let val = input.value;
    
    val = numericInputLimit(event, maxValue, maxDecimals);
    
    this.displayValue.set(val);
    input.value = val;

    // 6. Parsing for the backing variables
    const isValueEmpty = val === '' || val === '.';
    if (isValueEmpty) {
      this.chemForm.get(controlName)?.setValue(null, { emitEvent: false });
    } else if (val.endsWith('.')) {
      this.chemForm.get(controlName)?.setErrors({ 'incompleteDecimal': true });
    } else {      
      const parsedValue = parseFloat(val);
      this.chemForm.get(controlName)?.setValue(parsedValue, { emitEvent: false });
    }
    requestAnimationFrame(() => {
      if (document.activeElement === input) {
          input.value = val;
      }
    });
  }

  populateFormData(data: LabChemistryList | null): void {
    console.log("loading edit data chemistry");
    if(data){
      const formData = {
        id: data.id,
        c_LabId: data.c_LabId,
        testing_Type: data.testingType,
        c_SampleID: data.c_SampleID,
        c_LabreportID: data.c_LabreportID,
        c_DateSampled: data.c_DateSampled ? new Date(data.c_DateSampled) : null,
        c_DateTested: data.c_DateTested ? new Date(data.c_DateTested) : null,
        cod: data.cod,
        tvs: data.tvs,
        ts: data.ts,
        chlorides: data.chlorides,
        density: data.density,
        totalCarbon: data.totalCarbon,
        ammonia: data.ammonia,
        tkn: data.tkn,
        totalNitrogen: data.totalNitrogen,
        totalSulfur: data.totalSulfur,
        sulfides: data.sulfides,
        phosphate: data.phosphate,
        potassium: data.potassium,
        pH: data.pH,
        sodium: data.sodium,
        calcium: data.calcium,
        magnesium: data.magnesium,
        iron: data.iron,
        methanol: data.methanol,
        oilsAndGrease: data.oilsAndGrease,
        notes: data.notes
      };  
      this.chemForm.patchValue(formData);
    }
  }
  
  buildPayload(): SaveStreamBiologyChemistryRequest {
    const formData = this.chemForm.getRawValue();
    return {
      id: formData.id,
      streamID: this.streamID()!,
      labId: formData.c_LabId,
      testingType: formData.testing_Type,
      sampleID: formData.c_SampleID,
      labreportID: formData.c_LabreportID,
      dateSampled: formatDateOnly(formData.c_DateSampled),
      dateTested: formatDateOnly(formData.c_DateTested), 
      cod: normalizeNullable(formData.cod),
      tvs: normalizeNullable(formData.tvs),
      ts: normalizeNullable(formData.ts),
      chlorides: normalizeNullable(formData.chlorides),
      density: normalizeNullable(formData.density),
      totalCarbon: normalizeNullable(formData.totalCarbon),
      ammonia: normalizeNullable(formData.ammonia),
      tkn: normalizeNullable(formData.tkn),
      totalNitrogen: normalizeNullable(formData.totalNitrogen),
      totalSulfur: normalizeNullable(formData.totalSulfur),
      sulfides: normalizeNullable(formData.sulfides),
      phosphate: normalizeNullable(formData.phosphate),
      potassium: normalizeNullable(formData.potassium),
      pH: normalizeNullableToString(formData.pH),
      sodium: normalizeNullable(formData.sodium),
      calcium: normalizeNullable(formData.calcium),
      magnesium: normalizeNullable(formData.magnesium),
      iron: normalizeNullable(formData.iron),
      methanol: normalizeNullable(formData.methanol),
      oilsAndGrease: normalizeNullable(formData.oilsAndGrease),
      notes: formData.notes
    } as SaveStreamBiologyChemistryRequest;
  }  

  saveChemistry(): void {
    this.attemptSave.set(true);

    if (!this.validate()) {
      this.chemForm.markAllAsTouched();
      return;
    }

    this.isSaving.set(true);
    const payload = this.buildPayload();
    console.log("chemistry saving", payload);
    this.dialogRef.close(true);
    this.fsService.saveChemistry(payload).subscribe({
      next: (ok) => {
        this.isSaving.set(false);
        this.dialogRef.close(true);
      }
    });
  }

  validate(): boolean {
    let isBaseFormValid = this.chemForm.valid;
    return isBaseFormValid;
  }

  close(): void {
    this.dialogRef.close(false);
  }

}
